import { FieldErrors } from 'react-hook-form';
import { FormValues } from './types';

type Input = {
  errors: FieldErrors<FormValues>;
  dirtyFields: Partial<
    Record<
      keyof FormValues,
      boolean | Array<boolean> | undefined | Record<string, boolean>
    >
  >;
  hasLinkedPortal: boolean;
};

const useFirmSettingsFormState = ({
  errors,
  dirtyFields,
  hasLinkedPortal,
}: Input) => {
  const hasGeneralTabErrors = Object.keys(errors).some((key) =>
    [
      'firmName',
      'keyContactEmails',
      'systemDateFormat',
      'timezone',
      'subscriptionFlowEmailRecipients',
    ].includes(key),
  );
  const hasPortalTabGeneralSubTabErrors = Object.keys(errors).some((key) =>
    [
      'verifiedReplyToEmailAddress',
      'contactEmail',
      'contactPhoneNumber',
      'contactHours',
    ].includes(key),
  );
  const hasPortalTabBrandingSubTabErrors = Object.keys(errors).some((key) =>
    [
      'portalSubdomain',
      'lightMainLogo',
      'darkMainLogo',
      'panelColor',
      'secondaryColor',
      'highlightColor',
      'reportCoverColor',
      'reportCoverLogo',
      'squareLogo',
      'portalFooterText',
      'emailFooterText',
    ].includes(key),
  );
  const hasPortalTabErrors =
    hasPortalTabGeneralSubTabErrors || hasPortalTabBrandingSubTabErrors;

  const hasLinkedPortalFieldChanges =
    hasLinkedPortal &&
    [
      'firmName',
      'verifiedReplyToEmailAddress',
      'portalSubdomain',
      'lightMainLogo',
      'darkMainLogo',
      'panelColor',
      'squareLogo',
    ].some((key) => dirtyFields[key]);

  return {
    hasGeneralTabErrors,
    hasPortalTabGeneralSubTabErrors,
    hasPortalTabBrandingSubTabErrors,
    hasPortalTabErrors,
    hasLinkedPortalFieldChanges,
  };
};

export default useFirmSettingsFormState;
